import React from "react";

import "./TopBanners.scss";

const TopBanners = ({
  home,
  uiVariantBannerHeader,
  uiVariantSliderTagsSide,
}) => {
  const {
    bannerBottom1Image: banner1Image,
    bannerBottom1Link: banner1Link,
    bannerBottom1SeoName: banner1SeoName,
    bannerBottom2Image: banner2Image,
    bannerBottom2Link: banner2Link,
    bannerBottom2SeoName: banner2SeoName,
  } = home;

  return (
    <div className="top-banners">
      <div
        className="row"
        style={{
          flexDirection:
            uiVariantSliderTagsSide === "sx" ? "row-reverse" : "row",
        }}
      >
        <div className="col-lg-9">
          <a className="banner-link" href="#1">
            <div
              title={banner1SeoName}
              className="banner-container"
              style={{
                backgroundImage: `url(${banner1Image})`,
                borderRadius: uiVariantBannerHeader === "1" ? 15 : 0,
              }}
            />
          </a>
        </div>
        <div className="col-lg-3">
          <a className="banner-link" href="#2">
            <div
              title={banner2SeoName}
              className="banner-container"
              style={{
                backgroundImage: `url(${banner2Image})`,
                borderRadius: uiVariantBannerHeader === "1" ? 15 : 0,
              }}
            />
          </a>
        </div>
      </div>
    </div>
  );
};

export default TopBanners;
